import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '@components/Button'
import { motion } from 'framer-motion'

const ContentExpander = (props) => {
    const { children, open, duration = 0.55 } = props
    const [overflowHidden, setOverflowHidden] = useState(true)

    useEffect(() => {
        if (open) setOverflowHidden(false)
    }, [])

    return (
        <>
            <motion.div
                className={
                    overflowHidden
                        ? 'overflow-hidden h-auto w-auto'
                        : 'overflow-visible h-auto w-auto'
                }
                animate={{ height: open ? 'auto' : 0 }}
                initial={false}
                transition={{ duration: duration }}
                open={open}
                onAnimationStart={() => {
                    if (!open) setOverflowHidden(true)
                }}
                onAnimationComplete={() => {
                    setOverflowHidden(!open)
                }}
            >
                {children}
            </motion.div>
        </>
    )
}

ContentExpander.propTypes = {
    children: PropTypes.any,
    open: PropTypes.bool,
    duration: PropTypes.number,
}

export default ContentExpander
